export default __webpack_public_path__ + "static/media/176-switzerland.b1eaf7fa.svg";